import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import BoardTable from "../../components/common/board/BoardTable";
import BoardPagination from "../../components/common/board/BoardPagination";
import PageHeader from "../../components/common/ui/PageHeader";
import Cost_new from "./Cost_new";
import Cost_new_batch from "./Cost_new_batch";
import Cost_view from "./Cost_view";
import { getCosts } from "../../api/contract/cost";
import { formatDate } from "../../utils/date";

export default function CostList() {
  const { id: projectId } = useParams();

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [errMsg, setErrMsg] = useState("");
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);
  const [isModalOpenNewBatch, setIsModalOpenNewBatch] = useState(false);
  const fetchList = async () => {
    setLoading(true);
    setErrMsg("");

    try {
      const res = await getCosts(projectId, null, page, pageSize);
      setData(res.results || []);
      setTotal(res.count || 0);
    } catch (err) {
      console.error(err);
      setErrMsg("목록을 불러올 수 없습니다.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, [projectId, page, pageSize]);

  const rows = useMemo(() => data ?? [], [data]);

  const formatAmount = (v) =>
    v != null ? `${Number(v).toLocaleString()} 원` : "-";

  const columns = [
    { key: "code", header: "코드", render: (row) => row.meta.code },
    {
      key: "construction_type",
      header: "공종",
      render: (row) => row.meta.construction_type,
    },
    {
      key: "payment_date",
      header: "지불 날짜",
      render: (row) => formatDate(row.meta.payment_date),
    },    
    {
      key: "expected_amount",
      header: "계획 기성 금액",
      render: (row) => formatAmount(row.meta.expected_amount),
    },
    {
      key: "actual_amount",
      header: "실제 기성 금액",
      render: (row) => formatAmount(row.meta.actual_amount),
    },
    {
      key: "diff",
      header: "차액",
      render: (row) => {
        const a = row.meta.actual_amount;
        const e = row.meta.expected_amount;
        if (!a || !e) return "-";

        const diff = e - a;
        const percent = ((diff / e) * 100).toFixed(1);

        return (
          <span style={{ color: diff > 0 ? "red" : diff < 0 ? "blue" : "black" }}>
            {formatAmount(diff)} ({percent}%)
          </span>
        );
      },
    },
    {
      key: "rate",
      header: "기성 집행률 (%)",
      render: (row) => {
        const { actual_amount, expected_amount } = row.meta;
        if (!actual_amount || !expected_amount) return "-";

        const rate = ((actual_amount / expected_amount) * 100).toFixed(1);
        return (
          <span
            style={{
              color: rate < 100 ? "blue" : rate > 100 ? "red" : "black",
            }}
          >
            {rate} %
          </span>
        );
      },
    },
  ];

  return (
    <div className="p-6">

      <PageHeader>기성 등록·수정</PageHeader>
      
    {/* 기성 입력 버튼 */}
    <div className="flex justify-end mb-4 gap-2">
      <button
        className="btn-create"
        onClick={() => setIsModalOpenNew(true)}
      >
        기성 등록
      </button>

      <button
        className="btn-create"
        onClick={() => setIsModalOpenNewBatch(true)}
      >
        기성 일괄 등록
      </button>
    </div>
      {/* 기성 입력 모달 */}
      <Cost_new
        isOpen={isModalOpenNew}
        onClose={() => setIsModalOpenNew(false)}
        projectId={projectId}
        onCreated={fetchList}
      />
      <Cost_new_batch
        isOpen={isModalOpenNewBatch}
        onClose={() => setIsModalOpenNewBatch(false)}
        projectId={projectId}
        onCreated={fetchList}
      />
      {/* 테이블 */}
      <BoardTable
        columns={columns}
        rows={rows}
        loading={loading}
        error={errMsg}
        emptyText="기성 항목이 없습니다."
        onRowClick={(row) => setSelectedId(row.dns)}
      />

      {/* 페이지네이션 */}
      <div className="mt-4">
        <BoardPagination
          total={total}
          page={page}
          pageSize={pageSize}
          onPageChange={setPage}
        />
      </div>

      {/* 상세 보기 */}
      {selectedId && (
        <div className="mt-4 border-t pt-6">
          <Cost_view
            costId={selectedId}
            onClose={() => setSelectedId(null)}
            onUpdated={(newId) => {
              setSelectedId(newId);
              fetchList();
            }}
            onDeleted={() => {
              setSelectedId(null);
              fetchList();
            }}
          />
        </div>
      )}
    </div>
  );
}
